import { IAutocomplete, IFieldType, IFormFields, ICardTheme, IAddress } from "shared/types";
import { copy } from "shared/assets";
import { GooglePlacesAddressForm } from "shared/components/Form/AddressForm/GooglePlacesAddressForm";
import { Spacer } from "shared/layout";
import { Card, Title } from "shared/components";

const { venueProperties } = copy;

export const getFormFields = ({
  showExtendedInfo = true,
  address,
  setAddress,
  tempAddress,
  setTempAddress,
  submitAddress,
  handleBlurAddress,
  hasContainer,
}: {
  showExtendedInfo?: boolean;
  address: IAddress | null;
  setAddress: (address: IAddress | null) => void;
  tempAddress: IAddress | null;
  setTempAddress: (address: IAddress | null) => void;
  submitAddress: (address: IAddress | null) => void;
  handleBlurAddress: (address: IAddress | null) => void;
  hasContainer?: boolean;
}): IFormFields => {
  const fields: IFormFields = [];

  fields.push({
    name: "address",
    component: (
      <Card theme={hasContainer ? ICardTheme.secondary : ICardTheme.tertiary}>
        <Spacer size="m">
          <Title title={copy.venueProperties.address.title} />
          <GooglePlacesAddressForm
            address={address}
            setAddress={setAddress}
            tempAddress={tempAddress}
            setTempAddress={setTempAddress}
            defaultValues={(address || tempAddress || {}) as IAddress | undefined}
            submitAddress={submitAddress}
            blurAddress={handleBlurAddress}
          />
        </Spacer>
      </Card>
    ),
    style: {
      gridColumn: "span 4",
    },
  });

  if (showExtendedInfo) {
    fields.push(
      {
        name: "alternativeName",
        label: venueProperties.alternativeName.title,
        type: IFieldType.text,
        autocomplete: IAutocomplete.organization,
        note: venueProperties.alternativeName.note,
        style: {
          gridColumn: "span 4",
        },
      },
      {
        name: "contact",
        hideContainer: true,
        fields: [
          {
            name: "website",
            label: venueProperties.website.title,
            type: IFieldType.website,
            autocomplete: IAutocomplete.url,
            note: venueProperties.website.note,
          },
          {
            name: "email",
            label: venueProperties.email.title,
            type: IFieldType.email,
            note: venueProperties.email.note,
          },
          {
            name: "phone",
            label: venueProperties.phoneNumber.title,
            type: IFieldType.phone,
          },
        ],
        style: {
          gridColumn: "span 4",
        },
      }
    );
  }

  return fields;
};

export const defaultValues = {
  contact: {
    phone: {
      code: "BE",
    },
  },
};
